<template>
  <div class="datetimerange" :class="{small: small}">
    <i class="el-icon-time" v-if="preIcon"></i>
    <el-date-picker
        v-model="currentTimeStart" for-test="currentTimeStart"
        type="datetime"
        :clearable="true"
        placeholder="选择开始日期">
    </el-date-picker>
    <span>~</span>
    <el-date-picker
        v-model="currentTimeEnd" for-test="currentTimeEnd"
        type="datetime"
        :clearable="true"
        default-time="23:59:59"
        placeholder="选择结束日期">
    </el-date-picker>
    <i class="el-icon-circle-close close" v-if="close" @click="clickClose"></i>
  </div>
</template>
<style scoped lang="scss">
  .datetimerange {
    display: flex;
    border-bottom: 1px solid rgba(77, 167, 231, 0.5);
    position: relative;
    /deep/ .el-input--prefix .el-input__inner {
      border-bottom: none;
      padding: 0 5px;
      text-align: center;
    }
    /deep/ .el-input__icon {
      display: none;
    }
    /deep/ .el-input {
      width: 172px!important;
    }
    > span {
      padding: 0 20px;
      color: #fff;
      line-height: 30px;
    }
    > i {
      color: rgba(77, 167, 231, 0.5);
      line-height: 30px;
      padding: 0 10px;
      font-size: 18px;
    }
    > i.close {
      display: none;
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
      color: #fff;
      font-size: 14px;
    }
  }
  .datetimerange:hover {
    border-bottom: 1px solid rgba(255, 255, 255, 1);
    i.close {
      display: block;
    }
  }
  .small {
    /deep/ .el-input--prefix .el-input__inner {
      border-bottom: none;
      padding: 0;
    }
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/datetimerange/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/datetimerange/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/datetimerange/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-datetimerange')
  export default {
    name: 'base-datetimerange', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-datetimerange': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>